export default __webpack_public_path__ + "static/media/BS.53e688c6.svg";